import { read } from '@/api/rest';

const education = {
    index: async (options) => await read('/education?' + options.toString()),
    //view: async (id) => await read('/education/' + id),
};
export default education;